import {Navigate, Route, Routes } from "react-router-dom";

import HomepageCertificates from "./pages/homepage/certificates/HomepageCertificates";
import HomepageCollections from "./pages/homepage/collections/HomepageCollections";
import PasswordForgotten from "./pages/password_forgotten/PasswordForgotten";
import HomepageDashboard from "./pages/homepage/dashboard/HomepageDashboard";
import HomepageArtworks from "./pages/homepage/artworks/HomepageArtworks";
import TokenGallery from "./pages/homepage/tokens/TokenGallery";
import ExploreGallery from "./pages/homepage/explore/Explore";
import HomepageFrame from "./layouts/HomepageFrame";
import UnauthRoute from "./layouts/UnauthRoute";
import Account from "./pages/account/Account";
import AuthRoute from "./layouts/AuthRoute";
import PageFrame from "./layouts/PageFrame";
import Signup from "./pages/signup/Signup";
import Oauth from "./pages/oauth/Oauth";
import Login from './pages/login/Login';
import './themes.scss';
import './style.scss';
import './App.css';


function App() {
  
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />

      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />

      <Route element={<UnauthRoute />} >
        <Route path="/password-forgotten" element={<PasswordForgotten />} />
        <Route path="/oauth" element={<Oauth />} />
      </Route>

      <Route element={<AuthRoute />} >
        <Route element={<PageFrame />} >
          <Route element={<HomepageFrame />} >
            <Route path="/home" element={<HomepageDashboard />} />
            <Route path="/artworks/:code?" element={<HomepageArtworks />} />
            <Route path="/collections/:code?" element={<HomepageCollections />} />
            <Route path="/certificates/*" element={<HomepageCertificates />} />
            <Route path="/nfts" element={<TokenGallery />} />
            <Route path="/explore" element={<ExploreGallery />} />
          </Route>
          <Route path="/account/:tab?" element={<Account />} />

        </Route>
      </Route>
    </Routes>
  );
}

export default App;
